import BaseLoginField from 'registration/js/base/fields/login';

import template from 'registration/templates/dark/fields/login.html';

const LoginField = BaseLoginField.extend({
    template
});

export default LoginField;



// WEBPACK FOOTER //
// ./registration/static_source/js/registration/dark/fields/login.js